<template>
  <div>
    <em>{{ $t('form.working_hours.option_c.help') }}</em>
    <div>
      <label for="option_c_monday">
        <input type="checkbox" id="option_c_monday" v-model="days.monday">
        {{ $t('form.working_hours.days.monday') }}
      </label>
    </div>

    <div>
      <label for="option_c_tuesday">
        <input type="checkbox" id="option_c_tuesday" v-model="days.tuesday">
        {{ $t('form.working_hours.days.tuesday') }}
      </label>
    </div>

    <div>
      <label for="option_c_wednesday">
        <input type="checkbox" id="option_c_wednesday" v-model="days.wednesday">
        {{ $t('form.working_hours.days.wednesday') }}
      </label>
    </div>

    <div>
      <label for="option_c_thursday">
        <input type="checkbox" id="option_c_thursday" v-model="days.thursday">
        {{ $t('form.working_hours.days.thursday') }}
      </label>
    </div>

    <div>
      <label for="option_c_friday">
        <input type="checkbox" id="option_c_friday" v-model="days.friday">
        {{ $t('form.working_hours.days.friday') }}
      </label>
    </div>

    <div>
      <label for="option_c_saturday">
        <input type="checkbox" id="option_c_saturday" v-model="days.saturday">
        {{ $t('form.working_hours.days.saturday') }}
      </label>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      days: {
        monday: false,
        tuesday: false,
        wednesday: false,
        thursday: false,
        friday: false,
        saturday: false,
      },
    };
  },
  watch: {
    days: {
      handler() {
        this.$store.commit('updateWorkingHoursInputC', this.days);
      },
      deep: true,
    },
  },
};
</script>